export const FETCH_USER_NOTIFICATIONS_REQUEST = 'FETCH_USER_NOTIFICATIONS_REQUEST';
export const FETCH_USER_NOTIFICATIONS_SUCCESS = 'FETCH_USER_NOTIFICATIONS_SUCCESS';
export const FETCH_USER_NOTIFICATIONS_FAILURE = 'FETCH_USER_NOTIFICATIONS_FAILURE';

export const FETCH_UNREAD_USER_NOTIFICATIONS_REQUEST = 'FETCH_UNREAD_USER_NOTIFICATIONS_REQUEST';
export const FETCH_UNREAD_USER_NOTIFICATIONS_SUCCESS = 'FETCH_UNREAD_USER_NOTIFICATIONS_SUCCESS';
export const FETCH_UNREAD_USER_NOTIFICATIONS_FAILURE = 'FETCH_UNREAD_USER_NOTIFICATIONS_FAILURE';

export const FETCH_SENT_NOTIFICATIONS_REQUEST = 'FETCH_SENT_NOTIFICATIONS_REQUEST';
export const FETCH_SENT_NOTIFICATIONS_SUCCESS = 'FETCH_SENT_NOTIFICATIONS_SUCCESS';
export const FETCH_SENT_NOTIFICATIONS_FAILURE = 'FETCH_SENT_NOTIFICATIONS_FAILURE';

export const CREATE_NOTIFICATION_REQUEST = 'CREATE_NOTIFICATION_REQUEST';
export const CREATE_NOTIFICATION_SUCCESS = 'CREATE_NOTIFICATION_SUCCESS';
export const CREATE_NOTIFICATION_FAILURE = 'CREATE_NOTIFICATION_FAILURE';

export const DELETE_NOTIFICATION_REQUEST = 'DELETE_NOTIFICATION_REQUEST';
export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';
export const DELETE_NOTIFICATION_FAILURE = 'DELETE_NOTIFICATION_FAILURE';

export const MARK_NOTIFICATION_AS_READ_REQUEST = 'MARK_NOTIFICATION_AS_READ_REQUEST';
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_FAILURE = 'MARK_NOTIFICATION_AS_READ_FAILURE';

export const RESET_ERROR = 'RESET_ERROR';
